<div class="PGImageAutosize PGImageAutosize--{{fit != null ? fit.toUpperCase() : null}}">
        <div class="opacity-{{ isLoading ? '50' : '00' }}">
                <app-pg-loading [isOverlay]="true"></app-pg-loading>
        </div>
        <div class="PGImageAutosize-ImageContainer opacity-{{ isLoading ? '00' : '100' }}" #imageContainer></div>
</div>
